export type TransactionType =
  | 'LIQUIDITY_DEPOSITED'
  | 'LIQUIDITY_WITHDRAWN'
  | 'LOAN_CREATED'
  | 'LOAN_FULLY_REPAID_BY_BORROWER'
  | 'LOAN_PARTIALLY_REPAID_BY_BORROWER'
  | 'LOAN_REFINANCED_BY_BORROWER'
  | 'ASSET_SEIZED';
// add more here

export const transactionTypes = {
  LIQUIDITY_DEPOSITED: 'LIQUIDITY_DEPOSITED',
  LIQUIDITY_WITHDRAWN: 'LIQUIDITY_WITHDRAWN',
  LOAN_CREATED: 'LOAN_CREATED',
  LOAN_FULLY_REPAID_BY_BORROWER: 'LOAN_FULLY_REPAID_BY_BORROWER',
  LOAN_PARTIALLY_REPAID_BY_BORROWER: 'LOAN_PARTIALLY_REPAID_BY_BORROWER',
  LOAN_REFINANCED_BY_BORROWER: 'LOAN_REFINANCED_BY_BORROWER',
  ASSET_SEIZED: 'ASSET_SEIZED',
  // add more here
} as const;
